import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";

import { isActiveModule, getNavItems } from "../../Utils/helpers";

import { PersonOutline } from "../../Assets/Icons";

export default function NavBar() {
  const { pathname } = useLocation();

  const {
    appUtilityProps: { hideDealsRoutes, hideCashRoutes },
  } = useAppUtilityContext();

  const navItems = useMemo(() => getNavItems({ hideDealsRoutes, hideCashRoutes }), [hideDealsRoutes, hideCashRoutes]);

  const profileActive = isActiveModule("/profile", pathname);

  return (
    <nav className="app-utility-navbar" aria-label="Primary">
      {navItems.map(({ Icon, navItemName, navRoute }, idx) => {
        const isActive = isActiveModule(navRoute, pathname);
        return (
          <Link
            key={idx}
            className={`navbar-item${isActive ? " active" : ""}`}
            to={navRoute}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className="nav-icon" />
            {navItemName}
          </Link>
        );
      })}
      <Link
        className={`navbar-item${profileActive ? " active" : ""}`}
        to="/profile"
        aria-current={profileActive ? "page" : undefined}
      >
        <PersonOutline className="nav-icon" />
        Profile
      </Link>
    </nav>
  );
}
